import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import PriceSimulatePage from './PriceSimulatePage';
import PriceSimulatorTriggerButton from './PriceSimulatorTriggerButton';

const manifest = {
  id: 'price-simulator-3d',
  nameKey: 'extensions.price_simulator_3d.name',
  descriptionKey: 'extensions.price_simulator_3d.description',
  icon: CalculateOutlinedIcon,
  route: '/price-simulate',
  menuItem: {
    labelKey: 'price_simulate.menu',
    path: '/price-simulate',
  },
  requiredExtensions: [],
  Page: PriceSimulatePage,
  contributions: [
    {
      slotId: 'order.item.price',
      Component: PriceSimulatorTriggerButton,
      priority: 10,
    },
    {
      slotId: 'product.sku.price',
      Component: PriceSimulatorTriggerButton,
      priority: 10,
    },
  ],
};

export default manifest;
